// Turns the server's 422 field list into one friendly message per demo-form field.
const REQUIRED = {
  business_name: "Please enter your business name.",
  contact_name: "Please enter your name.",
  work_email: "Please enter your work email, like name@company.com.",
  job_title: "Please enter your job title.",
  website: "Please enter your business website, like yourbrand.com.",
  industry: "Please enter your industry.",
  phone: "Please enter your phone number, like 416 555 1234.",
};
const EMAIL_INVALID = "That email doesn't look right. Use your work email, like name@company.com.";

export const FIELD_ORDER = ["business_name", "contact_name", "work_email", "job_title", "website", "industry",
  "phone", "company_size", "province", "demo_interests", "message"];

function friendly(field, item) {
  const blank = item.type === "missing" || item.type === "string_too_short" || item.msg?.endsWith("This field is required.");
  if (blank && REQUIRED[field]) return REQUIRED[field];
  if (field === "work_email") return EMAIL_INVALID;
  if (item.type === "string_too_long") return "That's too long. Please shorten it.";
  return (item.msg || "Please check this field.").replace(/^Value error, /, "");
}

/** Returns { field: message } for a FastAPI 422 list, or null when the error isn't about fields. */
export function fieldErrorsFrom(err) {
  const d = err?.response?.data?.detail;
  if (err?.response?.status !== 422 || !Array.isArray(d)) return null;
  const out = {};
  d.forEach((item) => {
    const field = (item.loc || []).filter((x) => typeof x === "string" && x !== "body").pop();
    if (field && !out[field]) out[field] = friendly(field, item);
  });
  return Object.keys(out).length ? out : null;
}

export function FieldError({ name, error }) {
  if (!error) return null;
  return <span id={`demo-error-${name}`} className="block mt-1 text-xs font-medium text-rose-600" data-testid={`demo-error-${name}`}>{error}</span>;
}

export const inputCls = (error) => `mt-1 w-full border rounded-xl px-3 py-2.5 bg-white focus:outline-none focus:ring-2 ${
  error ? "border-rose-500 focus:ring-rose-400" : "border-slate-300 focus:ring-cyan-500"}`;
